/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteAgentScheduleRequest = {
  agentId: string;
  scheduleId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export const DeleteAgentScheduleObject = {
  AgentScheduleDeleted: "agent.schedule.deleted",
} as const;
export type DeleteAgentScheduleObject = ClosedEnum<
  typeof DeleteAgentScheduleObject
>;

/**
 * Deletion result.
 */
export type DeleteAgentScheduleResponseBody = {
  object: DeleteAgentScheduleObject;
  id: string;
  deleted: boolean;
};

/** @internal */
export const DeleteAgentScheduleRequest$inboundSchema: z.ZodType<
  DeleteAgentScheduleRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  schedule_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "schedule_id": "scheduleId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteAgentScheduleRequest$Outbound = {
  agent_id: string;
  schedule_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteAgentScheduleRequest$outboundSchema: z.ZodType<
  DeleteAgentScheduleRequest$Outbound,
  z.ZodTypeDef,
  DeleteAgentScheduleRequest
> = z.object({
  agentId: z.string(),
  scheduleId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    scheduleId: "schedule_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteAgentScheduleRequestToJSON(
  deleteAgentScheduleRequest: DeleteAgentScheduleRequest,
): string {
  return JSON.stringify(
    DeleteAgentScheduleRequest$outboundSchema.parse(deleteAgentScheduleRequest),
  );
}
export function deleteAgentScheduleRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteAgentScheduleRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteAgentScheduleRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteAgentScheduleRequest' from JSON`,
  );
}

/** @internal */
export const DeleteAgentScheduleObject$inboundSchema: z.ZodNativeEnum<
  typeof DeleteAgentScheduleObject
> = z.nativeEnum(DeleteAgentScheduleObject);
/** @internal */
export const DeleteAgentScheduleObject$outboundSchema: z.ZodNativeEnum<
  typeof DeleteAgentScheduleObject
> = DeleteAgentScheduleObject$inboundSchema;

/** @internal */
export const DeleteAgentScheduleResponseBody$inboundSchema: z.ZodType<
  DeleteAgentScheduleResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: DeleteAgentScheduleObject$inboundSchema,
  id: z.string(),
  deleted: z.boolean(),
});
/** @internal */
export type DeleteAgentScheduleResponseBody$Outbound = {
  object: string;
  id: string;
  deleted: boolean;
};

/** @internal */
export const DeleteAgentScheduleResponseBody$outboundSchema: z.ZodType<
  DeleteAgentScheduleResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteAgentScheduleResponseBody
> = z.object({
  object: DeleteAgentScheduleObject$outboundSchema,
  id: z.string(),
  deleted: z.boolean(),
});

export function deleteAgentScheduleResponseBodyToJSON(
  deleteAgentScheduleResponseBody: DeleteAgentScheduleResponseBody,
): string {
  return JSON.stringify(
    DeleteAgentScheduleResponseBody$outboundSchema.parse(
      deleteAgentScheduleResponseBody,
    ),
  );
}
export function deleteAgentScheduleResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<DeleteAgentScheduleResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteAgentScheduleResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteAgentScheduleResponseBody' from JSON`,
  );
}
